module.exports = "/_next/static/images/shopify-16bb48ea17a73bcd240927d08365c2e3.png";